import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges,} from '@angular/core';
import {MatTableDataSource} from '@angular/material/table';
import {Router} from '@angular/router';
import {vProjetProg} from 'src/app/domain';
import {AppTranslateService} from 'src/app/modules/services/translate/app-translate.service';
import {ConfirmDialogService} from 'src/app/modules/services/ui/confirm-dialog.service';
import {icons} from 'src/app/ui/icons';

type Column = keyof vProjetProg | 'action';

@Component({
    selector: 'app-projet-prog-table',
    templateUrl: './projet-prog-table.component.html',
    styleUrls: ['./projet-prog-table.component.css'],
})
export class ProjetProgTableComponent implements OnInit, OnChanges {
    @Input() projets: vProjetProg[];
    @Output() sort = new EventEmitter<any>();
    displayedColumns: Column[] = [];
    dataSource = new MatTableDataSource<vProjetProg>();
    displayedColumnsFR: Column[] = [
        'planNo',
        'instNm',
        'planNmFr',
        'bizKindNmFr',
        'smallBizYn',
        'action',
    ];

    displayedColumnsAR: Column[] = [
        'planNo',
        'instNm',
        'planNmAr',
        'bizKindNmAr',
        'smallBizYn',
        'action',
    ];
    displayedColumnsEN: Column[] = [
        'planNo',
        'instNm',
        'planNmFr',
        'bizKindNmFr',
        'smallBizYn',
        'action',
    ];

    labels: Partial<Record<Column, string>> = {
        planNo: 'N° avis AO',
        epPlanMasterId: 'id',
        planNmFr: 'Objet A.O',
        planNmAr: 'Objet A.O',
        smallBizYn: 'Encouragement des PME',
        instNm: 'Acheteur publique',
        bizKindNmFr: 'Type de commande',
        bizKindNmAr: 'Type de commande',
    };

    icons = icons;
    @Input() ondelete: boolean;

    constructor(
        private confirmDialogService: ConfirmDialogService,
        private apptranstlte: AppTranslateService,
        private router: Router
    ) {
    }

    get readColumns() {
        if (this.getlang()) {
            this.displayedColumns = this.displayedColumnsAR;
        }
            // else if (this.apptranstlte.getDefaultLang() == 'en') {
            //   this.displayedColumns=this.displayedColumnsEN;
        // }
        else {
            this.displayedColumns = this.displayedColumnsFR;
        }
        return this.displayedColumns.filter((column) => column !== 'action');
    }

    getlang() {
        return this.apptranstlte.getDefaultLang() == 'ar';
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges): void {
        const {projets} = changes;
        if (projets.currentValue !== projets.previousValue) {
            this.loadDataSource(projets.currentValue);
        }
    }

    loadDataSource(projets: vProjetProg[]) {
        this.dataSource.data = projets;
    }

    detailprojet(projetprog: vProjetProg) {
        this.router.navigate([
            '/portail/projets/projetdetails',
            projetprog.epPlanMasterId,
        ]);
        // this.router.navigateByUrl('/portail/offerdetails')
    }

    onSortChange($event: any) {
        this.sort.emit({
            nameCol: $event.active as any,
            direction: ($event.direction.toUpperCase() || 'ASC') + ' nulls last',
        });
    }
}

function newEventEmitter<T>() {
    throw new Error('Function not implemented.');
}
